module.exports = __webpack_public_path__ + "static/media/5.811b8388.jpg";